import React from "react";

const ReviewConfirm = ({ data, onBack, onFinish }) => {
    return (
        <div className="form-container">
            <h2>Review & Confirm</h2>
            <div className="review-section">
                <h3>League Details</h3>
                <p><strong>Name:</strong> {data.leagueName}</p>
                <p><strong>Location:</strong> {data.leagueLocation}</p>
                <p><strong>Time Zone:</strong> {data.timeZone}</p>
                <p><strong>Locale:</strong> {data.locale}</p>
            </div>

            <div className="review-section">
                <h3>Players</h3>
                <ul>
                    {data.players.length > 0 ? (
                        data.players.map((player, index) => <li key={index}>{player}</li>)
                    ) : (
                        <p>No players added.</p>
                    )}
                </ul>
            </div>

            <div className="review-section">
                <h3>Handicap Setup</h3>
                <p><strong>Handicap Set Name:</strong> {data.handicapSetName}</p>
                <p><strong>Date Range:</strong> {data.startDate?.toDateString()} - {data.endDate?.toDateString()}</p>
                <ul>
                    {Object.entries(data.handicaps).map(([player, handicap]) => (
                        <li key={player}>{player}: {handicap}</li>
                    ))}
                </ul>
                <h3>Flights</h3>
                {data.flights.map((flight, index) => (
                    <div key={index}>
                        <p><strong>Flight Name:</strong> {flight.name}</p>
                        <p><strong>Handicap Range:</strong> {flight.min} - {flight.max}</p>
                    </div>
                ))}
            </div>

            <div className="review-section">
                <h3>Payout Setup</h3>
                <p><strong>Payout Set Name:</strong> {data.payoutSetName}</p>
                <p><strong>Date Range:</strong> {data.payoutStartDate?.toDateString()} - {data.payoutEndDate?.toDateString()}</p>
                {data.payoutGroups.map((group, index) => (
                    <div key={index}>
                        <p><strong>Group:</strong> {group.name}</p>
                        <ul>
                            {group.items.map((item, itemIndex) => (
                                <li key={itemIndex}>{item.name} (${item.amount}) - {item.type}</li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>

            <div className="review-section">
                <h3>Matches</h3>
                <ul>
                    {data.matches.length > 0 ? (
                        data.matches.map((match, index) => (
                            <li key={index}>{new Date(match.date).toDateString()}</li>
                        ))
                    ) : (
                        <p>No matches scheduled.</p>
                    )}
                </ul>
            </div>
        </div>
    );
};

export default ReviewConfirm;